import React from 'react';
import StaffPortalLogin from './StaffPortalLogin';

const AdminLogin = () => <StaffPortalLogin initialRole="admin" />;

export default AdminLogin;
